import React from "react";
import { Helmet } from "react-helmet";
import LandScapeDesign from "../../components/landScape-design/LandScapeDesign";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";

function LandScapeDesignPage({ setShow }) {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>LandScape Design | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title={"LandScape Design"} t={t} />
      <LandScapeDesign />
    </>
  );
}

export default LandScapeDesignPage;
